module.exports = __webpack_public_path__ + "static/media/mykonos.68701dce.jpg";